import React, { useEffect, useState } from "react";
import { Icon, Popover } from "antd";
import { Link } from "react-router-dom";
import { powerbiService } from "services";
import { Tooltip } from "@material-ui/core";

//Popup pour le power bi
export const PowerBiPopUp = (props) => {
  const { table } = props;
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState({});

  useEffect(() => {
    powerbiService.getToken().then((result) => {
      setToken(result.token);
    });

    return () => {
      setToken({});
    };
  }, []);

  const content = (
    <div className="powerBi-popup">
      <h2>Importation Power BI</h2>
      <ul className="list-button">
        <li className="li-label">
          <label>Lien pour les données : </label>
        </li>
        <li className="li-input">
          <input type="text" value={table.service.powerBiUrl()} readOnly />
          <button
            onClick={async () => {
              await navigator.clipboard.writeText(table.service.powerBiUrl());
              alert("Copié au presse-papier");
            }}
          >
            <Icon type="paper-clip" />
          </button>
        </li>
        <li className="li-label">
          <label>Authorization : </label>
        </li>
        <li className="li-input">
          <input type="text" value={`Bearer ${token}`} readOnly />
          <button
            onClick={async () => {
              await navigator.clipboard.writeText(`Bearer ${token}`);
              alert("Copié au presse-papier");
            }}
          >
            <Icon type="paper-clip" />
          </button>
        </li>
      </ul>
      <section>
        <Link to="/powerbi" className="lien">
          Voir les instructions pour importer dans Power BI
        </Link>
      </section>
    </div>
  );

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  return (
    <Popover
      content={content}
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
      placement="bottomRight"
      className="popup"
    >
      <Tooltip title="Importation Power BI">
        <span style={{ order: -1 }}>
          <button class="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit">
            <span class="material-icons MuiIcon-root">insights</span>
          </button>
        </span>
      </Tooltip>
    </Popover>
  );
};

export default PowerBiPopUp;
